/*
 * ToyFigureHub B2B storefront
 *
 * Two quantities per model:
 *   Selection (Draft) — what the buyer is picking with the + / − steppers. Saved in localStorage,
 *                       so it survives page changes and reloads. Committed with "Add to cart".
 *   Cart              — what is really in the Shopify cart. Edited live in the cart drawer / cart page.
 *
 * Mounts:
 *   [data-tfh-catalog]   order sheet (list / grid), filters, pagination
 *   [data-tfh-rail]      product rows                      (homepage, product page)
 *   [data-tfh-series]    series index                      (homepage)
 *   [data-tfh-product]   product page model table
 *   [data-tfh-cart]      cart review page
 * Global: selection bar, cart drawer, command search (Cmd/Ctrl+K or /), quick order (paste SKUs), reorder.
 *
 * Feed product: {i, h, t, img, c, cols:[handle], v:[[variantId, title, priceCents, available, img, stock|null]]}
 */
(function () {
  'use strict';
  if (window.TFH) return;

  const CFG = Object.assign({
    bag: 1, newDays: 45, moneyFormat: '${{amount}}',
    feedUrl: '/collections/all?view=tfhc-data&page=__PAGE__', customer: 'guest',
    themes: [], types: [], defaultType: 'Minifigure', seriesAlias: { G: 'G0', X: 'X0' },
    cartUrl: '/cart', checkoutUrl: '/checkout', collectionsUrl: '/collections',
  }, window.TFH_CONFIG || {});
  CFG.bag = Math.max(1, +CFG.bag || 1);
  const ALL = () => `${CFG.collectionsUrl}/all`;

  /* ================= utils ================= */
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const debounce = (fn, ms) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), ms); }; };
  const delimit = (n, d, t, s) => { const [a, b] = n.toFixed(d).split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (b ? s + b : ''); };
  function money(cents) {
    const n = (cents || 0) / 100;
    return CFG.moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: delimit(n, 2, ',', '.'), amount_no_decimals: delimit(n, 0, ',', '.'),
      amount_with_comma_separator: delimit(n, 2, '.', ','), amount_no_decimals_with_comma_separator: delimit(n, 0, '.', ','),
    }[k] || delimit(n, 2, ',', '.')));
  }
  const imgUrl = (src, w) => !src ? '' : /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=' + w) : src + (src.includes('?') ? '&' : '?') + 'width=' + w;
  const plural = (n, w) => `${n.toLocaleString()} ${w}${n === 1 ? '' : 's'}`;
  const codeOf = t => { const m = /^\s*([A-Za-z]+)\s*-?\s*\d/.exec(t || ''); const c = m ? m[1].toUpperCase() : ''; return CFG.seriesAlias[c] || c || 'Other'; };
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
  };
  const isTyping = () => { const a = document.activeElement; return !!a && (/INPUT|TEXTAREA|SELECT/.test(a.tagName) || a.isContentEditable); };
  const ICON = {
    search: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>',
    chev: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>',
    left: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 6-6 6 6 6"/></svg>',
    x: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>',
    list: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01"/></svg>',
    grid: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="1.5"/><rect x="14" y="3" width="7" height="7" rx="1.5"/><rect x="3" y="14" width="7" height="7" rx="1.5"/><rect x="14" y="14" width="7" height="7" rx="1.5"/></svg>',
    paste: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="8" y="3" width="8" height="4" rx="1"/><path d="M16 5h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2M9 12h6M9 16h4"/></svg>',
    filter: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 5h16M7 12h10M10 19h4"/></svg>',
    cart: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 4h2l2.4 11.2a2 2 0 0 0 2 1.6h7.7a2 2 0 0 0 2-1.5L21 8H6"/><circle cx="10" cy="20" r="1"/><circle cx="18" cy="20" r="1"/></svg>',
    plus: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    check: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12 5 5 9-10"/></svg>',
  };

  /* ================= toast / zoom / overlays ================= */
  let toastEl, toastT;
  function toast(msg, opts = {}) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'tfh-toast'; toastEl.setAttribute('role', 'status'); toastEl.setAttribute('aria-live', 'polite'); document.body.appendChild(toastEl); }
    toastEl.innerHTML = `${opts.error ? '' : `<span class="tfh-toast__ic">${ICON.check}</span>`}<span>${esc(msg)}</span>` + (opts.action ? `<button type="button">${esc(opts.action[0])}</button>` : '');
    if (opts.action) toastEl.querySelector('button').onclick = () => { toastEl.classList.remove('is-on'); opts.action[1](); };
    toastEl.classList.toggle('is-error', !!opts.error);
    toastEl.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(() => toastEl.classList.remove('is-on'), opts.ms || 3600);
  }
  function zoom(src) {
    const z = document.createElement('div'); z.className = 'tfh-zoom'; z.innerHTML = `<img src="${esc(src)}" alt="">`;
    const close = () => { z.remove(); document.removeEventListener('keydown', key, true); };
    const key = e => { if (e.key === 'Escape') { e.stopPropagation(); close(); } };
    z.addEventListener('click', close); document.addEventListener('keydown', key, true); document.body.appendChild(z);
  }
  function overlay(cls, html, onClose) {
    const m = document.createElement('div'); m.className = `tfh-ov ${cls}`;
    m.innerHTML = `<div class="tfh-ov__scrim" data-tfh-ov-close></div><div class="tfh-ov__box" role="dialog" aria-modal="true">${html}</div>`;
    const prev = document.activeElement;
    let closed = false;
    const close = () => { if (closed) return; closed = true; m.classList.remove('is-on'); setTimeout(() => m.remove(), 180); if (!$$('.tfh-ov.is-on').length) document.documentElement.classList.remove('tfh-lock'); document.removeEventListener('keydown', key); onClose && onClose(); if (prev && prev.focus) prev.focus(); };
    const key = e => { if (e.key === 'Escape' && !$('.tfh-zoom')) close(); };
    m.addEventListener('click', e => { if (e.target.closest('[data-tfh-ov-close]')) close(); });
    document.addEventListener('keydown', key);
    document.body.appendChild(m); document.documentElement.classList.add('tfh-lock');
    requestAnimationFrame(() => m.classList.add('is-on'));
    return { el: m, close };
  }

  /* ================= catalog data ================= */
  const toRaw = p => ({ i: p.i, h: p.h, t: p.t, img: p.img, c: p.c, cols: p.cols, v: p.v });
  const Data = {
    products: [], byId: new Map(), byVar: new Map(), byTitle: new Map(), ready: null, listeners: [], complete: true, extra: [],
    load() {
      if (this.ready) return this.ready;
      const key = 'tfh-feed:' + CFG.customer;
      let cached = null;
      try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
      const fresh = cached && Date.now() - cached.at < 5 * 60e3;
      const get = n => fetch(CFG.feedUrl.replace('__PAGE__', n), { credentials: 'same-origin' }).then(r => { if (!r.ok) throw new Error('Catalog feed ' + r.status); return r.text(); }).then(t => { try { return JSON.parse(t); } catch (e) { return JSON.parse(t.replace(/,(?=\s*[\],}])/g, ',null')); } });
      const fetchAll = async onFirst => {
        const first = await get(1);
        const pages = Math.max(1, first.pages || 1);
        const restP = Promise.all(Array.from({ length: pages - 1 }, (_, i) => get(i + 2)));
        if (onFirst && pages > 1) onFirst(first.products);
        const rest = await restP;
        const products = first.products.concat(...rest.map(r => r.products));
        try { sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), products })); } catch (e) {}
        return products;
      };
      const refresh = p => { this.prepare(p); this.complete = true; this.listeners.forEach(f => f()); };
      if (cached && cached.products) {
        this.ready = Promise.resolve(this.prepare(cached.products));
        if (!fresh) fetchAll().then(refresh).catch(() => {});
      } else {
        this.ready = new Promise((resolve, reject) => {
          let early = false;
          fetchAll(first => { early = true; this.complete = false; resolve(this.prepare(first)); })
            .then(all => { if (early) refresh(all); else resolve(this.prepare(all)); })
            .catch(reject);
        });
      }
      return this.ready;
    },
    onRefresh(fn) { this.listeners.push(fn); },
    prepare(raw) {
      const themeSet = new Set(CFG.themes.map(t => t.h));
      const typeMap = new Map(CFG.types.map(t => [t.h, t.t]));
      const now = Date.now(), seen = new Set();
      /* collection names make products findable by series/theme ("naruto", "star wars", "one piece") */
      const colName = new Map();
      CFG.themes.concat(CFG.types).forEach(t => colName.set(t.h, t.t));
      (CFG.facets || []).forEach(g => (g.items || []).forEach(it => { if (it.h) colName.set(it.h, it.t); (it.kids || []).forEach(k => { if (k.h) colName.set(k.h, k.t); }); }));
      const colText = cols => cols.map(h => (colName.get(h) || '') + ' ' + h.replace(/-/g, ' ')).join(' ');
      this.byId = new Map(); this.byVar = new Map(); this.byTitle = new Map();
      this.products = raw.concat(this.extra).filter(p => p.v && p.v.length && !seen.has(p.i) && seen.add(p.i)).map(p => {
        const cols = p.cols || [], prices = p.v.map(v => v[2]), ts = Date.parse(p.c) || 0;
        const tyl = cols.filter(h => typeMap.has(h)).map(h => typeMap.get(h));
        const o = {
          i: p.i, h: p.h, t: p.t, img: p.img, c: p.c, cols, v: p.v, ts, s: codeOf(p.t),
          th: cols.filter(h => themeSet.has(h)), ty: tyl.length ? tyl : [CFG.defaultType],
          min: Math.min(...prices), max: Math.max(...prices), avail: p.v.some(v => v[3]),
          fresh: ts > 0 && (now - ts) / 864e5 <= CFG.newDays,
          hay: (p.t + ' ' + p.h + ' ' + p.v.map(v => v[1]).join(' ') + ' ' + colText(cols)).toLowerCase(),
        };
        p.v.forEach(v => { this.byVar.set(v[0], o); this.byTitle.set(String(v[1]).trim().toUpperCase(), [o, v]); });
        this.byId.set(o.i, o);
        return o;
      });
      return this.products;
    },
    ensure(raw) {
      if (this.byId.has(raw.i)) return this.byId.get(raw.i);
      this.extra = this.extra.filter(p => p.i !== raw.i).concat([raw]);
      this.prepare(this.products.filter(p => !this.extra.some(x => x.i === p.i)).map(toRaw));
      return this.byId.get(raw.i);
    },
    variant(vid) { const p = this.byVar.get(vid); return p && p.v.find(v => v[0] === vid); },
  };

  function isSet(p, v) {
    const t = String(v[1]).toLowerCase().trim();
    if (/\bset\b|full|整套|套装/.test(t)) return true;
    const head = p.t.toLowerCase().split(/[\s&/,]+/)[0];
    return p.v.length > 1 && t === head;
  }
  const stepFor = (p, v) => (isSet(p, v) ? 1 : CFG.bag);

  /* ================= selection (survives navigation) ================= */
  const Draft = {
    key: 'tfh-selection:' + CFG.customer, map: new Map(), listeners: [],
    init() {
      store.get(this.key, []).forEach(([k, v]) => { if (v > 0) this.map.set(+k, +v); });
      addEventListener('storage', e => { if (e.key === this.key) { this.map = new Map((store.get(this.key, [])).map(([k, v]) => [+k, +v])); this.emit(); } });
    },
    get(vid) { return this.map.get(vid) || 0; },
    set(vid, q, silent) {
      q = Math.max(0, Math.floor(+q || 0));
      const v = Data.variant(vid);
      if (v && v[5] > 0 && q > v[5]) { q = v[5]; if (!silent) toast(`Only ${v[5].toLocaleString()} in stock for ${v[1]}`, { error: true }); }
      q ? this.map.set(vid, q) : this.map.delete(vid);
      this.save(); this.emit([vid]);
    },
    clear(vids) { const list = vids || [...this.map.keys()]; list.forEach(v => this.map.delete(v)); this.save(); this.emit(list); },
    save() { store.set(this.key, [...this.map]); },
    totals(vids) {
      let models = 0, units = 0, total = 0;
      for (const [vid, q] of this.map) { if (vids && !vids.includes(vid)) continue; const v = Data.variant(vid); models++; units += q; total += q * (v ? v[2] : 0); }
      return { models, units, total };
    },
    on(fn) { this.listeners.push(fn); },
    emit(vids) { this.listeners.forEach(f => { try { f(vids); } catch (e) { console.error(e); } }); },
  };
  Draft.init();

  /* ================= live cart ================= */
  const Cart = {
    qty: new Map(), lines: [], count: 0, total: 0, models: 0, pending: new Map(), listeners: [], loaded: false, loading: null,
    load() {
      if (this.loading) return this.loading;
      this.loading = fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(r => r.json()).then(c => { this.apply(c); return this; }).catch(() => this).finally(() => { this.loading = null; });
      return this.loading;
    },
    apply(c) {
      this.lines = c.items || []; this.count = c.item_count || 0; this.total = c.total_price || 0; this.note = c.note || '';
      this.qty = new Map();
      this.lines.forEach(l => this.qty.set(l.variant_id, (this.qty.get(l.variant_id) || 0) + l.quantity));
      for (const [vid, q] of this.pending) q ? this.qty.set(vid, q) : this.qty.delete(vid);
      this.recount(); this.loaded = true;
      this.emit();
      if (!this.pending.size) dawnBubble(this.count, this.total);
    },
    recount() {
      this.models = this.qty.size;
      if (this.pending.size) {
        let units = 0, total = 0;
        for (const [vid, q] of this.qty) { units += q; const v = Data.variant(vid), l = this.lines.find(x => x.variant_id === vid); total += q * (l ? l.final_price : v ? v[2] : 0); }
        this.count = units; this.total = total;
      }
    },
    get(vid) { return this.pending.has(vid) ? this.pending.get(vid) : (this.qty.get(vid) || 0); },
    set(vid, q) {
      q = Math.max(0, Math.floor(+q || 0));
      this.pending.set(vid, q);
      q ? this.qty.set(vid, q) : this.qty.delete(vid);
      this.recount(); this.emit([vid]); this.flushSoon();
    },
    flushSoon: debounce(() => Cart.flush(), 250),
    busy: null,
    async flush() {
      if (this.busy) await this.busy;
      if (!this.pending.size) return;
      const updates = Object.fromEntries(this.pending);
      this.pending = new Map();
      document.documentElement.classList.add('tfh-saving');
      this.busy = (async () => {
        try {
          const r = await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
          const j = await r.json();
          if (!r.ok || j.status) { toast(j.description || j.message || 'Could not update the cart', { error: true }); await this.load(); return; }
          this.apply(j);
        } catch (e) { toast('Network error — cart not updated', { error: true }); await this.load(); }
        finally { document.documentElement.classList.remove('tfh-saving'); this.busy = null; }
      })();
      await this.busy;
      if (this.pending.size) this.flush();
    },
    /* add quantities on top of what is in the cart; returns {added, failed} */
    async add(entries) {
      entries = entries.filter(([, q]) => q > 0);
      if (!entries.length) return { added: [], failed: [] };
      await this.flush();
      const added = [], failed = [];
      const post = items => fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      for (let i = 0; i < entries.length; i += 100) {
        const chunk = entries.slice(i, i + 100);
        const r = await post(chunk.map(([id, quantity]) => ({ id, quantity })));
        if (r.ok) { added.push(...chunk); continue; }
        for (const e of chunk) {               // one by one so a single sold-out model doesn't block the rest
          const r1 = await post([{ id: e[0], quantity: e[1] }]);
          if (r1.ok) added.push(e); else { let msg = ''; try { msg = (await r1.json()).description; } catch (x) {} failed.push([...e, msg]); }
        }
      }
      await this.load();
      return { added, failed };
    },
    on(fn) { this.listeners.push(fn); },
    emit(vids) { this.listeners.forEach(f => { try { f(vids); } catch (e) { console.error(e); } }); },
  };

  async function addSelection(vids, btn) {
    const entries = (vids || [...Draft.map.keys()]).map(v => [v, Draft.get(v)]).filter(([, q]) => q > 0);
    if (!entries.length) return;
    const old = btn && btn.innerHTML;
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
    try {
      const { added, failed } = await Cart.add(entries);
      Draft.clear(added.map(e => e[0]));
      const pcs = added.reduce((s, e) => s + e[1], 0);
      if (added.length) toast(`Added ${plural(added.length, 'model')} · ${pcs.toLocaleString()} pcs`, { action: ['View cart', openDrawer] });
      if (failed.length) setTimeout(() => toast(`${plural(failed.length, 'model')} could not be added${failed[0][2] ? ': ' + failed[0][2] : ''}`, { error: true, ms: 6000 }), added.length ? 1200 : 0);
    } catch (e) { toast('Could not add to cart — please try again', { error: true }); }
    finally { if (btn) { btn.disabled = false; btn.innerHTML = old; } }
  }

  /* ================= shared rendering ================= */
  function stepper(vid, p, v, kind = 'sel', size = '') {
    const q = kind === 'cart' ? Cart.get(vid) : Draft.get(vid), avail = v ? v[3] : 1;
    return `<div class="tfh-step ${size}" data-tfh-step="${vid}" data-kind="${kind}">
      <button type="button" data-tfh-dec ${!avail || !q ? 'disabled' : ''} aria-label="Decrease">−</button>
      <input type="number" inputmode="numeric" min="0" step="${p && v ? stepFor(p, v) : 1}" value="${q || ''}" placeholder="0" ${avail ? '' : 'disabled'} aria-label="Quantity${v ? ' for ' + esc(v[1]) : ''}">
      <button type="button" data-tfh-inc ${avail ? '' : 'disabled'} aria-label="Increase">+</button></div>`;
  }
  const count = (p, getter) => { let n = 0; for (const v of p.v) if (getter(v[0])) n++; return n; };
  const inCartModels = p => count(p, vid => Cart.get(vid));
  const selModels = p => count(p, vid => Draft.get(vid));
  const priceLabel = p => p.min === p.max ? money(p.min) : `${money(p.min)}<span class="tfh-dim"> – ${money(p.max)}</span>`;
  const stockText = v => !v[3] ? '<span class="tfh-stock is-out">Sold out</span>' : v[5] > 0 ? `<span class="tfh-stock">${v[5].toLocaleString()}</span>` : '<span class="tfh-stock">In stock</span>';
  const badges = p => { const c = inCartModels(p), s = selModels(p); return `<span data-tfh-badges class="tfh-badges">${s ? `<span class="tfh-pill tfh-pill--sel">${s} selected</span>` : ''}${c ? `<span class="tfh-pill tfh-pill--cart">${c} in cart</span>` : ''}</span>`; };

  function cardHTML(p, open) {
    return `<article class="tfh-card${open ? ' is-open' : ''}" data-tfh-card="${p.i}" tabindex="0">
      <div class="tfh-card__media"><img loading="lazy" src="${esc(imgUrl(p.img, 400))}" alt="" width="400" height="400">
        <span class="tfh-card__flags">${p.fresh ? '<span class="tfh-flag tfh-flag--new">New</span>' : ''}${!p.avail ? '<span class="tfh-flag tfh-flag--out">Sold out</span>' : ''}</span></div>
      <div class="tfh-card__body">
        <div class="tfh-card__title">${esc(p.t)}</div>
        <div class="tfh-card__meta">${plural(p.v.length, 'model')}</div>
        <div class="tfh-card__foot"><span class="tfh-card__price">${priceLabel(p)}</span>${badges(p)}</div>
        <span class="tfh-card__cta">${open ? 'Close' : `${ICON.plus} Select models`}</span>
      </div></article>`;
  }
  function rowHTML(p, open) {
    return `<div class="tfh-row${open ? ' is-open' : ''}" data-tfh-card="${p.i}" tabindex="0" role="button" aria-expanded="${!!open}">
      <span class="tfh-row__img"><img loading="lazy" src="${esc(imgUrl(p.img, 120))}" alt="" width="56" height="56"></span>
      <span class="tfh-row__main"><span class="tfh-row__title">${esc(p.t)}</span>
        <span class="tfh-row__meta">${plural(p.v.length, 'model')}${p.fresh ? '<span class="tfh-flag tfh-flag--new">New</span>' : ''}${!p.avail ? '<span class="tfh-flag tfh-flag--out">Sold out</span>' : ''}</span></span>
      <span class="tfh-row__price">${priceLabel(p)}</span>
      <span class="tfh-row__status">${badges(p)}</span>
      <span class="tfh-row__go"><span class="tfh-btn tfh-btn--sm ${open ? '' : 'tfh-btn--soft'}">${open ? 'Close' : 'Select'}</span></span>
    </div>`;
  }
  function variantsHTML(p) {
    return `<div class="tfh-vt" role="table">
      <div class="tfh-vt__head" role="row"><span></span><span>Model</span><span>Unit price</span><span>Stock</span><span>In cart</span><span>Qty to add</span><span>Subtotal</span></div>
      ${p.v.map(v => { const q = Draft.get(v[0]), c = Cart.get(v[0]); return `<div class="tfh-vt__row${q ? ' has-qty' : ''}${v[3] ? '' : ' is-out'}" role="row" data-tfh-vid="${v[0]}">
        <button type="button" class="tfh-vt__img" data-tfh-zoom="${esc(imgUrl(v[4] || p.img, 1000))}" aria-label="Enlarge ${esc(v[1])}"><img loading="lazy" src="${esc(imgUrl(v[4] || p.img, 140))}" alt=""></button>
        <span class="tfh-vt__name" title="${esc(v[1])}">${esc(v[1])}${isSet(p, v) ? '<em class="tfh-tag">Full set</em>' : ''}</span>
        <span class="tfh-vt__price">${money(v[2])}</span>
        <span class="tfh-vt__stock">${stockText(v)}</span>
        <span class="tfh-vt__cart" data-tfh-incart="${v[0]}">${c ? `<span class="tfh-pill tfh-pill--cart">${c}</span>` : '<span class="tfh-dim">—</span>'}</span>
        ${stepper(v[0], p, v)}
        <span class="tfh-vt__line" data-tfh-line>${q ? money(q * v[2]) : ''}</span></div>`; }).join('')}
    </div>`;
  }
  const vidsOf = p => p.v.map(v => v[0]);
  function panelBar(p) {
    const s = Draft.totals(vidsOf(p)), singles = p.v.filter(v => v[3] && !isSet(p, v)).length;
    return `<div class="tfh-panel__sum">${s.models ? `<span class="tfh-dim">Selected</span> <b>${s.models}</b> models · <b>${s.units.toLocaleString()}</b> pcs · <b>${money(s.total)}</b>` : '<span class="tfh-dim">Use + to choose quantities, then add them to your cart.</span>'}</div>
      <div class="tfh-panel__acts">
        ${singles > 1 ? `<button type="button" class="tfh-btn tfh-btn--sm tfh-btn--quiet" data-tfh-each>+${CFG.bag} each</button>` : ''}
        ${s.models ? '<button type="button" class="tfh-btn tfh-btn--sm tfh-btn--quiet" data-tfh-reset>Clear</button>' : ''}
        <button type="button" class="tfh-btn tfh-btn--pri" data-tfh-add-product ${s.models ? '' : 'disabled'}>${ICON.cart}<span>${s.models ? `Add ${s.units.toLocaleString()} pcs to cart` : 'Add to cart'}</span></button>
      </div>`;
  }
  /* ---------- product gallery (main image + thumbnails; more images load from /products/<handle>.js) ---------- */
  const imgKey = u => (u || '').split('?')[0].split('/').pop();
  function galleryImgs(p) { const out = []; const add = u => { if (u && !out.some(x => imgKey(x) === imgKey(u))) out.push(u); }; add(p.img); p.v.forEach(v => add(v[4])); return out; }
  const galThumbs = imgs => imgs.length > 1 ? imgs.map((u, i) => `<button type="button" class="tfh-gal__th${i ? '' : ' is-on'}" data-tfh-gal-th="${esc(u)}" aria-label="Image ${i + 1}"><img loading="lazy" src="${esc(imgUrl(u, 160))}" alt=""></button>`).join('') : '';
  function galleryHTML(p) {
    const imgs = galleryImgs(p), first = imgs[0] || '';
    return `<div class="tfh-gal" data-tfh-gal="${esc(p.h)}">
      <button type="button" class="tfh-gal__main" data-tfh-zoom="${esc(imgUrl(first, 1400))}" aria-label="Enlarge image">${first ? `<img data-tfh-gal-main src="${esc(imgUrl(first, 900))}" alt="${esc(p.t)}">` : ''}<span class="tfh-gal__hint">${ICON.search || ''}Click to enlarge</span></button>
      <div class="tfh-gal__thumbs" data-tfh-gal-thumbs>${galThumbs(imgs)}</div>
    </div>`;
  }
  const galCache = new Map();
  function hydrateGalleries(scope = document) {
    $$('[data-tfh-gal]:not([data-hyd])', scope).forEach(g => {
      g.setAttribute('data-hyd', '');
      const h = g.dataset.tfhGal;
      if (!galCache.has(h)) galCache.set(h, fetch(`/products/${encodeURIComponent(h)}.js`).then(r => r.ok ? r.json() : null).then(j => (j && j.images) || []).catch(() => []));
      galCache.get(h).then(list => {
        const box = $('[data-tfh-gal-thumbs]', g); if (!box) return;
        const imgs = [...$$('[data-tfh-gal-th]', box).map(b => b.dataset.tfhGalTh)];
        if (!imgs.length) { const m = $('[data-tfh-gal-main]', g); if (m) imgs.push(m.src); }
        list.forEach(u => { u = u.startsWith('//') ? 'https:' + u : u; if (!imgs.some(x => imgKey(x) === imgKey(u))) imgs.push(u); });
        const on = ($('.tfh-gal__th.is-on', box) || {}).dataset;
        box.innerHTML = galThumbs(imgs);
        if (on && on.tfhGalTh) $$('[data-tfh-gal-th]', box).forEach(b => b.classList.toggle('is-on', imgKey(b.dataset.tfhGalTh) === imgKey(on.tfhGalTh)));
      });
    });
  }
  function galShow(g, src) {
    const main = $('[data-tfh-gal-main]', g), btn = $('.tfh-gal__main', g); if (!main || !src) return;
    main.src = imgUrl(src, 900); btn.dataset.tfhZoom = imgUrl(src, 1400);
    $$('[data-tfh-gal-th]', g).forEach(b => b.classList.toggle('is-on', imgKey(b.dataset.tfhGalTh) === imgKey(src)));
  }
  new MutationObserver(debounce(() => hydrateGalleries(), 60)).observe(document.documentElement, { childList: true, subtree: true });

  function panelHTML(p, opts = {}) {
    if (opts.gallery) return `<div class="tfh-panel tfh-panel--g" data-tfh-panel="${p.i}"><div class="tfh-panel__gal">${galleryHTML(p)}</div><div class="tfh-panel__main">${panelInner(p, opts)}</div></div>`;
    return `<div class="tfh-panel" data-tfh-panel="${p.i}">${panelInner(p, opts)}</div>`;
  }
  function panelInner(p, opts) {
    return `
      ${opts.head !== false ? `<div class="tfh-panel__head"><div><b>${esc(p.t)}</b><span>${plural(p.v.length, 'model')} · ${priceLabel(p)}${opts.link !== false ? ` · <a href="/products/${esc(p.h)}">Product details</a>` : ''}</span></div></div>` : ''}
      ${variantsHTML(p)}
      <div class="tfh-panel__bar" data-tfh-pbar="${p.i}">${panelBar(p)}</div>`;
  }

  function syncSteppers(kind, vids) {
    const base = `[data-tfh-step][data-kind="${kind}"]`;
    const sel = vids ? vids.map(v => `[data-tfh-step="${v}"][data-kind="${kind}"]`).join(',') : base;
    if (!sel) return;
    $$(sel).forEach(st => {
      const vid = +st.dataset.tfhStep, q = kind === 'cart' ? Cart.get(vid) : Draft.get(vid), inp = st.querySelector('input');
      if (document.activeElement !== inp) inp.value = q || '';
      const dec = st.querySelector('[data-tfh-dec]'); if (dec) dec.disabled = !q;
      const row = st.closest('[data-tfh-vid]');
      if (row && kind === 'sel') { row.classList.toggle('has-qty', !!q); const line = row.querySelector('[data-tfh-line]'), v = Data.variant(vid); if (line && v) line.textContent = q ? money(q * v[2]) : ''; }
    });
  }
  function syncProducts(vids) {
    const pids = new Set((vids || [...Data.byVar.keys()]).map(v => Data.byVar.get(+v)).filter(Boolean).map(p => p.i));
    pids.forEach(pid => {
      const p = Data.byId.get(pid);
      $$(`[data-tfh-card="${pid}"] [data-tfh-badges]`).forEach(b => { b.outerHTML = badges(p); });
      $$(`[data-tfh-pbar="${pid}"]`).forEach(b => { b.innerHTML = panelBar(p); });
    });
    (vids || [...Data.byVar.keys()]).forEach(vid => $$(`[data-tfh-incart="${vid}"]`).forEach(el => { const c = Cart.get(+vid); el.innerHTML = c ? `<span class="tfh-pill tfh-pill--cart">${c}</span>` : '<span class="tfh-dim">—</span>'; }));
  }
  Draft.on(vids => { syncSteppers('sel', vids); syncProducts(vids); });
  Cart.on(vids => { syncSteppers('cart', vids); if (!vids) syncProducts(); else syncProducts(vids); });

  /* ================= global selection bar ================= */
  let bar;
  function selectionBar() {
    if (document.querySelector('[data-tfh-cart]') || document.querySelector('.tfh-auth-aside')) return;
    if (!bar) {
      bar = document.createElement('div'); bar.className = 'tfh-selbar'; bar.hidden = true;
      bar.innerHTML = '<div class="tfh-selbar__in"></div>';
      document.body.appendChild(bar);
      barDrag(bar);
    }
    const s = Draft.totals();
    const box = bar.firstElementChild;
    if (s.models) {
      box.className = 'tfh-selbar__in is-sel';
      box.innerHTML = `<span class="tfh-selbar__grip" data-bar-grip title="Drag to move · double-click to reset"><svg viewBox="0 0 6 10" aria-hidden="true"><circle cx="1" cy="1" r="1"/><circle cx="5" cy="1" r="1"/><circle cx="1" cy="5" r="1"/><circle cx="5" cy="5" r="1"/><circle cx="1" cy="9" r="1"/><circle cx="5" cy="9" r="1"/></svg></span><span class="tfh-selbar__dot"></span><span class="tfh-selbar__info"><span class="tfh-selbar__label">Selected · not in cart yet</span><span><b>${s.models}</b> models · <b>${s.units.toLocaleString()}</b> pcs</span></span>
        <span class="tfh-selbar__total">${money(s.total)}</span>
        <button type="button" class="tfh-btn tfh-btn--ghost-dark" data-tfh-clear-sel>Clear</button>
        <button type="button" class="tfh-btn tfh-btn--pri tfh-btn--lg" data-tfh-add-all>${ICON.cart}<span>Add all to cart</span></button><button type="button" class="tfh-selbar__min" data-bar-min aria-label="Collapse">${ICON.chev.replace('m9 6 6 6-6 6', 'm15 6-6 6 6 6')}</button>`;
    } else if (Cart.count) {
      box.className = 'tfh-selbar__in is-cart';
      box.innerHTML = `<span class="tfh-selbar__grip" data-bar-grip title="Drag to move · double-click to reset"><svg viewBox="0 0 6 10" aria-hidden="true"><circle cx="1" cy="1" r="1"/><circle cx="5" cy="1" r="1"/><circle cx="1" cy="5" r="1"/><circle cx="5" cy="5" r="1"/><circle cx="1" cy="9" r="1"/><circle cx="5" cy="9" r="1"/></svg></span><span class="tfh-selbar__info"><span class="tfh-selbar__label">Your cart</span><span><b>${Cart.models}</b> models · <b>${Cart.count.toLocaleString()}</b> pcs</span></span>
        <span class="tfh-selbar__total">${money(Cart.total)}</span>
        <button type="button" class="tfh-btn tfh-btn--ghost-dark" data-tfh-open-cart>View cart</button>
        <a class="tfh-btn tfh-btn--pri tfh-btn--lg" href="${CFG.checkoutUrl}">Checkout</a><button type="button" class="tfh-selbar__min" data-bar-min aria-label="Collapse">${ICON.chev.replace('m9 6 6 6-6 6', 'm15 6-6 6 6 6')}</button>`;
    }
    const show = !!(s.models || Cart.count);
    bar.hidden = !show;
    document.documentElement.classList.toggle('tfh-has-bar', show);
  }
  /* desktop: drag the bar anywhere (position remembered), collapse to a pill; double-click the grip to reset */
  function barDrag(el) {
    const KEY = 'tfh-bar-pos', MIN = 'tfh-bar-min';
    const place = pos => {
      if (!pos || innerWidth < 750) { el.classList.remove('is-moved'); el.style.left = el.style.top = ''; return; }
      const r = el.getBoundingClientRect(), x = Math.min(Math.max(8, pos.x), innerWidth - r.width - 8), y = Math.min(Math.max(8, pos.y), innerHeight - r.height - 8);
      el.classList.add('is-moved'); el.style.left = x + 'px'; el.style.top = y + 'px';
    };
    el.classList.toggle('is-min', !!store.get(MIN, false));
    requestAnimationFrame(() => place(store.get(KEY, null)));
    addEventListener('resize', debounce(() => place(store.get(KEY, null)), 120));
    el.addEventListener('pointerdown', e => {
      const g = e.target.closest('[data-bar-grip]'); if (!g || innerWidth < 750) return;
      e.preventDefault(); const r = el.getBoundingClientRect(), dx = e.clientX - r.left, dy = e.clientY - r.top;
      el.classList.add('is-dragging'); g.setPointerCapture(e.pointerId);
      const move = ev => place({ x: ev.clientX - dx, y: ev.clientY - dy });
      const up = ev => { g.removeEventListener('pointermove', move); g.removeEventListener('pointerup', up); el.classList.remove('is-dragging'); store.set(KEY, { x: ev.clientX - dx, y: ev.clientY - dy }); };
      g.addEventListener('pointermove', move); g.addEventListener('pointerup', up);
    });
    el.addEventListener('dblclick', e => { if (e.target.closest('[data-bar-grip]')) { store.set(KEY, null); place(null); } });
    el.addEventListener('click', e => { if (e.target.closest('[data-bar-min]')) { const m = !el.classList.contains('is-min'); el.classList.toggle('is-min', m); store.set(MIN, m); requestAnimationFrame(() => place(store.get(KEY, null))); } });
  }
  const selectionBarSoon = debounce(selectionBar, 50);
  Draft.on(selectionBarSoon); Cart.on(selectionBarSoon);

  /* ================= header cart + drawer ================= */
  /* Dawn's header owns the cart icon; re-render it through the Section Rendering API
     whenever the server cart changes, the same way Dawn's own cart code does. */
  let bubbleCount = null, bubbleReq = 0;
  function dawnBubble(count, total) {
    const el = document.getElementById('cart-icon-bubble'), key = count + ':' + total;
    if (!el || key === bubbleCount) return;
    if (bubbleCount === null) { bubbleCount = key; return; }   // first load: Liquid already rendered it
    bubbleCount = key;
    // instant feedback; the server render below replaces it
    let b = el.querySelector('.cart-count-bubble'), a = el.querySelector('.tfh-cart-amt');
    if (count && !b) { b = document.createElement('div'); b.className = 'cart-count-bubble'; b.innerHTML = '<span aria-hidden="true"></span>'; el.appendChild(b); }
    if (count && !a) { a = document.createElement('span'); a.className = 'tfh-cart-amt'; el.appendChild(a); }
    const n = b && b.querySelector('span[aria-hidden="true"]');
    if (n) n.textContent = count < 100 ? count : '99+';
    if (a) a.textContent = money(total);
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const req = ++bubbleReq;
    fetch(`${root}?sections=cart-icon-bubble&_=${Date.now()}`, { cache: 'no-store' }).then(r => r.json()).then(j => {
      if (req !== bubbleReq || !j['cart-icon-bubble']) return;
      const doc = new DOMParser().parseFromString(j['cart-icon-bubble'], 'text/html');
      const sec = doc.querySelector('.shopify-section');
      el.innerHTML = sec ? sec.innerHTML : doc.body.innerHTML;
      el.classList.remove('tfh-bump'); void el.offsetWidth; el.classList.add('tfh-bump');
    }).catch(() => {});
  }
  function headerCart() {
    $$('[data-tfh-cart-count]').forEach(el => { el.textContent = Cart.models > 999 ? '999+' : Cart.models; el.hidden = !Cart.models; });
    $$('[data-tfh-cart-total]').forEach(el => { el.textContent = Cart.count ? money(Cart.total) : 'Cart'; });
  }
  Cart.on(debounce(headerCart, 40));

  function cartGroups() {
    const groups = new Map();
    for (const l of Cart.lines) { if (!groups.has(l.product_id)) groups.set(l.product_id, { title: l.product_title, url: (l.url || '').split('?')[0], img: l.image, lines: [] }); groups.get(l.product_id).lines.push(l); }
    return [...groups.values()];
  }
  function ensureLines() {
    const extra = new Map();
    Cart.lines.filter(l => !Data.byVar.has(l.variant_id)).forEach(l => { if (!extra.has(l.product_id)) extra.set(l.product_id, { i: l.product_id, h: l.handle, t: l.product_title, img: l.image, c: '', cols: [], v: [] }); extra.get(l.product_id).v.push([l.variant_id, l.variant_title || l.title, l.price, 1, l.image, null]); });
    extra.forEach(raw => Data.ensure(raw));
  }
  let drawer = null;
  function drawerHTML() {
    ensureLines();
    const groups = cartGroups(), s = Draft.totals();
    return `<header class="tfh-drawer__head"><div><h2>Cart</h2><span>${Cart.models ? `${plural(Cart.models, 'model')} · ${Cart.count.toLocaleString()} pcs` : ''}</span></div><button type="button" class="tfh-icon" data-tfh-ov-close aria-label="Close">${ICON.x}</button></header>
      ${s.models ? `<div class="tfh-drawer__sel"><span>You also have <b>${s.models}</b> selected models (${s.units.toLocaleString()} pcs) not in the cart yet.</span><button type="button" class="tfh-btn tfh-btn--sm tfh-btn--pri" data-tfh-add-all>Add them</button></div>` : ''}
      <div class="tfh-drawer__body">${groups.length ? groups.map(g => `
        <section class="tfh-dg"><a class="tfh-dg__h" href="${esc(g.url)}"><span class="tfh-dg__img">${g.img ? `<img src="${esc(imgUrl(g.img, 96))}" alt="" loading="lazy">` : ''}</span><span class="tfh-dg__t">${esc(g.title)}</span><b>${money(g.lines.reduce((t, l) => t + l.final_line_price, 0))}</b></a>
        ${g.lines.map(l => { const p = Data.byVar.get(l.variant_id), v = p && Data.variant(l.variant_id);
          return `<div class="tfh-dl" data-tfh-vid="${l.variant_id}"><span class="tfh-dl__n">${esc(l.variant_title || l.title)}<small>${money(l.final_price)}</small></span>${stepper(l.variant_id, p, v, 'cart', 'is-sm')}<span class="tfh-dl__t">${money(l.final_line_price)}</span></div>`; }).join('')}</section>`).join('')
        : `<div class="tfh-empty">${ICON.cart}<b>Your cart is empty</b><span>Select models in the catalog, then press Add to cart.</span><a class="tfh-btn" href="${ALL()}">Browse the catalog</a></div>`}</div>
      <footer class="tfh-drawer__foot">
        <div class="tfh-kv"><span>Subtotal</span><b>${money(Cart.total)}</b></div>
        <p class="tfh-dim">Shipping and taxes are calculated at checkout.</p>
        <div class="tfh-drawer__btns"><a class="tfh-btn" href="${CFG.cartUrl}">Review order</a><a class="tfh-btn tfh-btn--pri${Cart.count ? '' : ' is-disabled'}" href="${CFG.checkoutUrl}">Checkout</a></div>
      </footer>`;
  }
  function paintDrawer() {
    if (!drawer) return;
    const box = $('.tfh-drawer__in', drawer.el);
    if (box.contains(document.activeElement) && document.activeElement.tagName === 'INPUT') return;
    box.innerHTML = drawerHTML();
  }
  function openDrawer() {
    if (drawer) return;
    drawer = overlay('tfh-drawer', '<div class="tfh-drawer__in"></div>', () => { drawer = null; });
    paintDrawer();
    Promise.all([Cart.load(), Data.load().catch(() => {})]).then(paintDrawer);
  }
  Cart.on(debounce(vids => { if (drawer && !vids) paintDrawer(); }, 120));
  Draft.on(debounce(() => { if (drawer) paintDrawer(); }, 120));

  /* ================= command search ================= */
  let palette = null;
  function openPalette(initial = '') {
    if (palette) return;
    palette = overlay('tfh-cmd', `
      <label class="tfh-cmd__input">${ICON.search}<input type="search" placeholder="Search model code, SKU or name…" autocomplete="off" value="${esc(initial)}" aria-label="Search"><kbd>Esc</kbd></label>
      <div class="tfh-cmd__body"><div class="tfh-cmd__hint">Loading catalog…</div></div>
      <div class="tfh-cmd__foot"><span><kbd>↑</kbd><kbd>↓</kbd> move</span><span><kbd>Enter</kbd> open</span><span><kbd>+</kbd> select a model</span></div>`, () => { palette = null; });
    const input = $('input', palette.el), body = $('.tfh-cmd__body', palette.el);
    let items = [], idx = 0;
    const mark = () => $$('.tfh-cmd__item', body).forEach((el, i) => el.classList.toggle('is-on', i === idx));
    const render = () => {
      if (!Data.products.length) return;
      const q = input.value.trim().toLowerCase();
      items = [];
      if (!q) { body.innerHTML = `<div class="tfh-cmd__hint">Type a product code like <b>WM6177</b> or a single model like <b>WM2666</b>.</div>
        <div class="tfh-cmd__quick"><a href="${ALL()}">All products</a><a href="${ALL()}?new=1">New arrivals</a><a href="${ALL()}?incart=1">Items in my cart</a><button type="button" data-tfh-bulk>Paste a SKU list</button></div>`; return; }
      const toks = q.split(/\s+/), exactV = Data.byTitle.get(q.toUpperCase());
      const prods = Data.products.filter(p => toks.every(t => p.hay.includes(t))).sort((a, b) => (b.t.toLowerCase().startsWith(q) - a.t.toLowerCase().startsWith(q)) || b.ts - a.ts).slice(0, 8);
      let html = '';
      if (exactV) { const [p, v] = exactV; items.push({ type: 'v', p, v }); html += `<div class="tfh-cmd__sec">Model</div><div class="tfh-cmd__item" data-tfh-vid="${v[0]}"><img src="${esc(imgUrl(v[4] || p.img, 96))}" alt=""><span><b>${esc(v[1])}</b><small>${esc(p.t)} · ${money(v[2])}${Cart.get(v[0]) ? ` · ${Cart.get(v[0])} in cart` : ''}</small></span>${stepper(v[0], p, v, 'sel', 'is-sm')}<button type="button" class="tfh-btn tfh-btn--sm tfh-btn--pri" data-tfh-add-one="${v[0]}">Add</button></div>`; }
      if (prods.length) html += '<div class="tfh-cmd__sec">Products</div>' + prods.map(p => { items.push({ type: 'p', p }); return `<a class="tfh-cmd__item" href="/products/${esc(p.h)}"><img src="${esc(imgUrl(p.img, 96))}" alt=""><span><b>${esc(p.t)}</b><small>${esc(p.s)} · ${plural(p.v.length, 'model')} · ${priceLabel(p)}</small></span>${ICON.chev}</a>`; }).join('');
      body.innerHTML = items.length ? html + `<a class="tfh-cmd__all" href="${ALL()}?q=${encodeURIComponent(input.value.trim())}">Show all results in the catalog →</a>` : `<div class="tfh-cmd__hint">No match for “${esc(input.value)}”.</div>`;
      idx = 0; mark();
    };
    input.addEventListener('input', debounce(render, 60));
    input.addEventListener('keydown', e => {
      if (e.key === 'ArrowDown') { e.preventDefault(); idx = Math.min(items.length - 1, idx + 1); mark(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); idx = Math.max(0, idx - 1); mark(); }
      else if (e.key === 'Enter') { e.preventDefault(); const it = items[idx]; if (!it) { location.href = `${ALL()}?q=${encodeURIComponent(input.value.trim())}`; return; } if (it.type === 'v') bump(it.v[0], 1, 'sel'); else location.href = `/products/${it.p.h}`; }
      else if ((e.key === '+' || e.key === '=') && items[idx] && items[idx].type === 'v') { e.preventDefault(); bump(items[idx].v[0], 1, 'sel'); }
    });
    body.addEventListener('click', e => { if (e.target.closest('[data-tfh-bulk]')) { palette.close(); openBulk(); } });
    Data.load().then(() => { body.innerHTML = ''; render(); }).catch(() => { body.innerHTML = '<div class="tfh-cmd__hint">Could not load the catalog.</div>'; });
    setTimeout(() => input.focus(), 30);
  }

  /* ================= quick order (paste SKUs) ================= */
  function parseBulk(text) {
    return text.split(/\r?\n|;/).map(s => s.trim()).filter(Boolean).map(line => {
      const m = /^(.+?)[\s,\t:x×*]+(\d+)\s*(?:pcs?|pieces?)?$/i.exec(line);
      const code = (m ? m[1] : line).trim().replace(/[,;]$/, ''), qty = Math.max(1, parseInt(m ? m[2] : '1', 10) || 1), U = code.toUpperCase();
      const hit = Data.byTitle.get(U);
      if (hit) return { code, qty, label: hit[1][1], v: [hit[1]] };
      const prod = Data.products.find(p => p.t.toUpperCase() === U) || Data.products.find(p => p.t.toUpperCase().split(/[\s&/,]+/)[0] === U);
      if (prod) return { code, qty, label: prod.t, each: true, v: prod.v.filter(v => v[3] && !isSet(prod, v)) };
      return { code, qty, miss: true };
    });
  }
  /* Quick order: shared by the pop-up (openBulk) and the Quick order page section (QuickOrder) */
  const BULK_PH = 'WM2666 10&#10;WM2667, 5&#10;PG8294 2&#10;TV1207 x 20';
  const bulkThumb = v => { const p = Data.byVar.get(v[0]); const src = v[4] || (p && p.img); return src ? `<img loading="lazy" src="${esc(imgUrl(src, 80))}" alt="">` : '<span></span>'; };
  function bulkWire(box, { onAdded } = {}) {
    const ta = $('textarea', box), pv = $('[data-bulk-preview]', box), btn = $('[data-bulk-add]', box), sum = $('[data-bulk-sum]', box), empty = pv.innerHTML;
    let rows = [];
    const draw = () => {
      rows = ta.value.trim() ? parseBulk(ta.value) : [];
      if (!rows.length) { pv.innerHTML = empty; btn.disabled = true; sum.textContent = ''; box.classList.remove('has-rows'); return; }
      box.classList.add('has-rows');
      let lines = 0, units = 0, total = 0, miss = 0;
      pv.innerHTML = rows.map(r => {
        if (r.miss) { miss++; return `<div class="tfh-bl is-miss"><span class="tfh-bl__img"></span><b>${esc(r.code)}</b><span>Not found</span></div>`; }
        const sub = r.v.reduce((s, v) => s + v[2] * r.qty, 0); lines += r.v.length; units += r.v.length * r.qty; total += sub;
        return `<div class="tfh-bl"><span class="tfh-bl__img">${r.v[0] ? bulkThumb(r.v[0]) : ''}</span><b>${esc(r.label)}</b><span>${r.each ? `${r.v.length} models × ${r.qty}` : `× ${r.qty}`}</span><em>${money(sub)}</em></div>`;
      }).join('');
      sum.innerHTML = (lines ? `<b>${plural(lines, 'model')}</b> · ${units.toLocaleString()} pcs · <b>${money(total)}</b>` : '') + (miss ? `${lines ? ' · ' : ''}<span class="tfh-bl__miss">${miss} not found</span>` : '');
      btn.disabled = !lines;
    };
    ta.addEventListener('input', debounce(draw, 150));
    const file = $('[data-bulk-file]', box);
    if (file) file.addEventListener('change', () => { const f = file.files[0]; if (!f) return; const rd = new FileReader(); rd.onload = () => { ta.value = String(rd.result).split(/\r?\n/).map(l => l.split(/[,;\t]/).filter(Boolean).slice(0, 2).join(' ')).filter(Boolean).join('\n'); draw(); }; rd.readAsText(f); file.value = ''; });
    const clr = $('[data-bulk-clear]', box);
    if (clr) clr.addEventListener('click', () => { ta.value = ''; draw(); ta.focus(); });
    btn.addEventListener('click', async () => {
      const map = new Map(); rows.forEach(r => { if (!r.miss) r.v.forEach(v => map.set(v[0], (map.get(v[0]) || 0) + r.qty)); });
      const label = btn.innerHTML; btn.disabled = true; btn.innerHTML = 'Adding…';
      const { added, failed } = await Cart.add([...map]);
      btn.innerHTML = label;
      toast(`Added ${plural(added.length, 'model')}`, { action: ['View cart', openDrawer] });
      if (failed.length) setTimeout(() => toast(`${plural(failed.length, 'model')} could not be added`, { error: true }), 1200);
      onAdded && onAdded(added, failed); draw();
    });
    Data.load().then(draw);
    return { ta, draw };
  }
  function openBulk() {
    const ov = overlay('tfh-bulk', `
      <header class="tfh-modal__head"><div><h2>Quick order</h2><p>Paste one model per line with a quantity. A product code adds that quantity of every model in it.</p></div><button type="button" class="tfh-icon" data-tfh-ov-close aria-label="Close">${ICON.x}</button></header>
      <div class="tfh-bulk__grid">
        <div class="tfh-bulk__col"><div class="tfh-bulk__label">Your list</div><textarea spellcheck="false" placeholder="${BULK_PH}" aria-label="SKU list"></textarea></div>
        <div class="tfh-bulk__col"><div class="tfh-bulk__label">Preview</div><div class="tfh-bulk__preview" data-bulk-preview><div class="tfh-dim">Matches appear here as you type.</div></div></div>
      </div>
      <footer class="tfh-modal__foot"><span class="tfh-dim" data-bulk-sum></span><button type="button" class="tfh-btn" data-tfh-ov-close>Cancel</button><button type="button" class="tfh-btn tfh-btn--pri" data-bulk-add disabled>${ICON.cart}<span>Add to cart</span></button></footer>`);
    const w = bulkWire(ov.el, { onAdded: () => ov.close() });
    setTimeout(() => w.ta.focus(), 30);
  }
  function QuickOrder(root) {
    root.innerHTML = `
      <div class="tfh-qo">
        <div class="tfh-qo__col">
          <div class="tfh-qo__label"><b>1</b> Paste your list <span class="tfh-dim">— one code per line, then a quantity</span></div>
          <textarea spellcheck="false" placeholder="${BULK_PH}" aria-label="SKU list"></textarea>
          <div class="tfh-qo__tools">
            <label class="tfh-btn tfh-btn--sm"><input type="file" accept=".csv,.txt,text/csv,text/plain" data-bulk-file hidden>Upload CSV</label>
            <button type="button" class="tfh-btn tfh-btn--sm tfh-btn--quiet" data-bulk-clear>Clear</button>
            <span class="tfh-dim">Formats: <code>WM2666 10</code> · <code>WM2666, 10</code> · <code>WM2666 x 10</code> · a product code adds every model</span>
          </div>
        </div>
        <div class="tfh-qo__col">
          <div class="tfh-qo__label"><b>2</b> Check the matches</div>
          <div class="tfh-qo__preview" data-bulk-preview><div class="tfh-qo__empty">${ICON.paste}<span>Matches, prices and totals appear here as you type.</span></div></div>
        </div>
        <div class="tfh-qo__bar"><span class="tfh-qo__label"><b>3</b></span><span class="tfh-qo__sum" data-bulk-sum></span><button type="button" class="tfh-btn tfh-btn--pri tfh-btn--lg" data-bulk-add disabled>${ICON.cart}<span>Add to cart</span></button></div>
      </div>`;
    bulkWire(root);
  }

  /* ================= global events ================= */
  const getQ = (vid, kind) => kind === 'cart' ? Cart.get(vid) : Draft.get(vid);
  const setQ = (vid, q, kind) => kind === 'cart' ? Cart.set(vid, q) : Draft.set(vid, q);
  function bump(vid, dir, kind) {
    const p = Data.byVar.get(vid), v = p && Data.variant(vid), st = p ? stepFor(p, v) : 1, cur = getQ(vid, kind);
    setQ(vid, dir > 0 ? (cur < st ? st : Math.floor(cur / st) * st + st) : (cur <= st ? 0 : Math.ceil(cur / st) * st - st), kind);
  }
  document.addEventListener('click', e => {
    const t = e.target; let el;
    if ((el = t.closest('[data-tfh-inc]'))) { e.preventDefault(); const s = el.closest('[data-tfh-step]'); return bump(+s.dataset.tfhStep, 1, s.dataset.kind); }
    if ((el = t.closest('[data-tfh-dec]'))) { e.preventDefault(); const s = el.closest('[data-tfh-step]'); return bump(+s.dataset.tfhStep, -1, s.dataset.kind); }
    if (t.closest('.tfh-step')) return;
    if ((el = t.closest('[data-tfh-gal-th]'))) { e.preventDefault(); return galShow(el.closest('[data-tfh-gal]'), el.dataset.tfhGalTh); }
    if ((el = t.closest('.tfh-vt__img[data-tfh-zoom]'))) { const g = $('[data-tfh-gal]', el.closest('[data-tfh-panel]') || document.createElement('div')); if (g) { e.preventDefault(); const img = el.querySelector('img'); galShow(g, img && img.getAttribute('src')); if (matchMedia('(max-width: 899px)').matches) g.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); return; } }
    if ((el = t.closest('[data-tfh-zoom]'))) { e.preventDefault(); return zoom(el.dataset.tfhZoom); }
    if (t.closest('[data-tfh-open-cart]')) { e.preventDefault(); return setTimeout(openDrawer, 0); }
    if (t.closest('[data-tfh-open-search]')) { e.preventDefault(); return openPalette(); }
    if (t.closest('[data-tfh-open-bulk]')) { e.preventDefault(); return openBulk(); }
    if ((el = t.closest('[data-tfh-add-all]'))) { e.preventDefault(); return addSelection(null, el); }
    if ((el = t.closest('[data-tfh-add-one]'))) { e.preventDefault(); const vid = +el.dataset.tfhAddOne; if (!Draft.get(vid)) Draft.set(vid, 1); return addSelection([vid], el); }
    if (t.closest('[data-tfh-clear-sel]')) { const prev = [...Draft.map]; Draft.clear(); return toast('Selection cleared', { action: ['Undo', () => prev.forEach(([v, q]) => Draft.set(v, q, true))] }); }
    if ((el = t.closest('[data-tfh-add-product]'))) { const p = Data.byId.get(+el.closest('[data-tfh-panel]').dataset.tfhPanel); return addSelection(vidsOf(p), el); }
    if ((el = t.closest('[data-tfh-reorder]'))) {
      e.preventDefault();
      let lines = []; try { lines = JSON.parse(el.dataset.tfhReorder); } catch (err) {}
      if (!lines.length || el.disabled) return;
      const old = el.innerHTML; el.disabled = true; el.textContent = 'Adding…';
      Cart.add(lines).then(({ added, failed }) => {
        const pcs = added.reduce((s, e) => s + e[1], 0);
        if (added.length) toast(`Added ${plural(added.length, 'model')} · ${pcs.toLocaleString()} pcs from your order`, { action: ['View cart', openDrawer] });
        if (failed.length) setTimeout(() => toast(`${plural(failed.length, 'model')} could not be added${failed[0][2] ? ': ' + failed[0][2] : ''}`, { error: true, ms: 6000 }), added.length ? 1200 : 0);
      }).catch(() => toast('Could not add to cart — please try again', { error: true }))
        .finally(() => { el.disabled = false; el.innerHTML = old; });
      return;
    }
    if ((el = t.closest('[data-tfh-each]'))) { const p = Data.byId.get(+el.closest('[data-tfh-panel]').dataset.tfhPanel); p.v.forEach(v => { if (v[3] && !isSet(p, v)) Draft.set(v[0], Draft.get(v[0]) + CFG.bag, true); }); return; }
    if ((el = t.closest('[data-tfh-reset]'))) { const p = Data.byId.get(+el.closest('[data-tfh-panel]').dataset.tfhPanel); Draft.clear(vidsOf(p)); }
  });
  document.addEventListener('change', e => {
    const st = e.target.closest && e.target.closest('[data-tfh-step]'); if (!st || e.target.tagName !== 'INPUT') return;
    const vid = +st.dataset.tfhStep, p = Data.byVar.get(vid), v = p && Data.variant(vid);
    let q = Math.max(0, Math.floor(+e.target.value || 0)); const s = p ? stepFor(p, v) : 1;
    if (q && q % s) q = Math.ceil(q / s) * s;
    setQ(vid, q, st.dataset.kind); e.target.value = q || '';
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Enter' && e.target.closest && e.target.closest('[data-tfh-step]')) { e.preventDefault(); e.target.blur(); return; }
    if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') { e.preventDefault(); openPalette(); return; }
    if (e.key === '/' && !isTyping() && !$('.tfh-ov')) { const local = $('.tfh-sheet__search input'); e.preventDefault(); local ? local.focus() : openPalette(); }
  });
  document.addEventListener('focusin', e => { if (e.target.matches && e.target.matches('.tfh-step input')) e.target.select(); });

  /* ================= order sheet (catalog) ================= */
  const PRICE = [['u1', 'Under $1', c => c < 100], ['1-3', '$1 – $3', c => c >= 100 && c < 300], ['3-10', '$3 – $10', c => c >= 300 && c < 1000], ['10+', '$10 and up', c => c >= 1000]];
  const SORTS = {
    new: (a, b) => b.ts - a.ts || a.t.localeCompare(b.t),
    code: (a, b) => a.t.localeCompare(b.t, 'en', { numeric: true }),
    pa: (a, b) => a.min - b.min, pd: (a, b) => b.min - a.min,
    vars: (a, b) => b.v.length - a.v.length,
  };
  const SIZES = [50, 100, 200];

  function Catalog(root) {
    const scope = root.dataset.scope || '', scopeTitle = root.dataset.scopeTitle || '';
    const S = { q: [], qRaw: '', th: new Set(), se: new Set(), ty: new Set(), price: '', fresh: false, stock: true, cart: false, sel: false, sort: 'new',
      view: store.get('tfh-view2', root.dataset.defaultView || 'list'), size: store.get('tfh-size', 50), page: 1, list: [], open: null, more: {}, scoped: !!scope };
    if (!SIZES.includes(S.size)) S.size = 50;
    let SERIES = [], rendered = false;
    /* filter groups from the Filter menu (Theme settings → B2B wholesale) */
    const slug = t => String(t).toLowerCase().replace(/&/g, 'and').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const FACETS = (CFG.facets || []).map((g, gi) => {
      const nodes = [];
      (g.items || []).forEach(it => {
        const kids = (it.kids || []).filter(k => k.h && k.h !== 'all');
        const own = it.h && it.h !== 'all' ? it.h : '';
        const hs = [...new Set([own, ...kids.map(k => k.h)].filter(Boolean))];
        if (!hs.length) return;
        nodes.push({ k: own || 'g-' + slug(it.t), t: it.t, hs, kids: kids.filter(k => k.h !== own).map(k => ({ k: k.h, t: k.t, hs: [k.h] })) });
      });
      const byKey = new Map(); nodes.forEach(n => { byKey.set(n.k, n); n.kids.forEach(c => { if (!byKey.has(c.k)) byKey.set(c.k, c); }); });
      return { key: 'f' + gi, slug: slug(g.t), t: g.t, nodes, byKey };
    }).filter(g => g.nodes.length);
    FACETS.forEach(g => { S[g.key] = new Set(); });
    const colSet = p => p._cs || (p._cs = new Set(p.cols));
    const nodeHit = (p, n) => { const cs = colSet(p); return n.hs.some(h => cs.has(h)); };
    S.tree = new Set(); S.seQ = '';

    root.innerHTML = `
      <div class="tfh-sheet">
        <aside class="tfh-sheet__side" aria-label="Filters">
          <div class="tfh-sheet__sidehead"><b>Filters</b><button type="button" class="tfh-icon" data-close aria-label="Close">${ICON.x}</button></div>
          <div data-filters></div>
          <div class="tfh-sheet__sidefoot"><button type="button" class="tfh-btn" data-clear>Clear all</button><button type="button" class="tfh-btn tfh-btn--pri" data-close>Show results</button></div>
        </aside>
        <div class="tfh-sheet__main">
          <div class="tfh-sheet__bar">
            <label class="tfh-input tfh-sheet__search">${ICON.search}<input type="search" placeholder="Search model, SKU or name" autocomplete="off" enterkeyhint="search" aria-label="Search products"><kbd>/</kbd></label>
            <button type="button" class="tfh-btn tfh-sheet__filterbtn" data-open-filters>${ICON.filter}<span>Filters</span></button>
            <select class="tfh-select" data-sort aria-label="Sort">
              <option value="new">Newest</option><option value="code">Model A–Z</option><option value="pa">Price, low to high</option><option value="pd">Price, high to low</option><option value="vars">Most models</option>
            </select>
            <div class="tfh-seg" role="group" aria-label="View"><button type="button" data-viewbtn="list" aria-label="List view" title="List">${ICON.list}</button><button type="button" data-viewbtn="grid" aria-label="Grid view" title="Grid">${ICON.grid}</button></div>
            <button type="button" class="tfh-btn tfh-sheet__bulk" data-tfh-open-bulk>${ICON.paste}<span>Quick order</span></button>
          </div>
          <div class="tfh-sheet__meta" data-meta></div>
          <div class="tfh-sheet__list" data-list></div>
          <nav class="tfh-pager" data-pager aria-label="Pages"></nav>
        </div>
        <div class="tfh-scrim" data-close></div>
      </div>`;

    const list = $('[data-list]', root), input = $('.tfh-sheet__search input', root), sheet = $('.tfh-sheet', root), pager = $('[data-pager]', root);

    function matches(p, skip) {
      if (S.scoped && scope && !p.cols.includes(scope)) return false;
      for (const tok of S.q) if (!p.hay.includes(tok)) return false;
      for (const g of FACETS) { const sel = S[g.key]; if (skip !== g.key && sel.size && ![...sel].some(k => { const n = g.byKey.get(k); return n && nodeHit(p, n); })) return false; }
      if (skip !== 'th' && S.th.size && !p.th.some(h => S.th.has(h))) return false;
      if (skip !== 'se' && S.se.size && !S.se.has(p.s)) return false;
      if (skip !== 'ty' && S.ty.size && !p.ty.some(t => S.ty.has(t))) return false;
      if (skip !== 'price' && S.price) { const f = PRICE.find(x => x[0] === S.price); if (f && !f[2](p.min)) return false; }
      if (skip !== 'fresh' && S.fresh && !p.fresh) return false;
      if (skip !== 'stock' && S.stock && !p.avail) return false;
      if (skip !== 'cart' && S.cart && !inCartModels(p)) return false;
      if (skip !== 'sel' && S.sel && !selModels(p)) return false;
      return true;
    }
    const counts = (key, keysOf) => { const m = new Map(); for (const p of Data.products) if (matches(p, key)) for (const k of keysOf(p)) m.set(k, (m.get(k) || 0) + 1); return m; };

    function apply(keep) {
      S.list = Data.products.filter(p => matches(p)).sort(SORTS[S.sort]);
      if (!keep) S.page = 1;
      const pages = Math.max(1, Math.ceil(S.list.length / S.size));
      S.page = Math.min(Math.max(1, S.page), pages);
      renderPage(); renderFilters(); renderMeta(); writeUrl();
    }
    function renderPage(scroll) {
      const start = (S.page - 1) * S.size, items = S.list.slice(start, start + S.size);
      if (S.open && !items.some(p => p.i === S.open)) S.open = null;
      list.className = `tfh-sheet__list is-${S.view}`;
      list.innerHTML = !S.list.length
        ? `<div class="tfh-empty">${ICON.search}<b>No products match</b><span>Try a shorter search or remove a filter.</span>${S.stock && Data.products.some(p => matches(p, 'stock')) ? `<button type="button" class="tfh-btn tfh-btn--pri" data-show-soldout>Show ${Data.products.filter(p => matches(p, 'stock')).length} sold-out matches</button>` : ''}<button type="button" class="tfh-btn" data-clear>Clear all filters</button></div>`
        : (S.view === 'list' ? '<div class="tfh-rowhead"><span></span><span>Product</span><span>Price / pc</span><span>Status</span><span></span></div>' : '') +
          items.map(p => S.view === 'list' ? rowHTML(p, S.open === p.i) + (S.open === p.i ? panelHTML(p, { head: false, gallery: true }) : '') : cardHTML(p, S.open === p.i)).join('');
      if (S.view === 'grid' && S.open) placePanel();
      $$('[data-viewbtn]', root).forEach(b => b.classList.toggle('is-on', b.dataset.viewbtn === S.view));
      renderPager();
      if (scroll) { const top = list.getBoundingClientRect().top + scrollY - headerH() - 90; scrollTo({ top: Math.max(0, top), behavior: 'smooth' }); }
    }
    function renderPager() {
      const total = S.list.length, pages = Math.max(1, Math.ceil(total / S.size));
      const from = total ? (S.page - 1) * S.size + 1 : 0, to = Math.min(total, S.page * S.size);
      const nums = []; const add = n => nums.push(n);
      const win = 1; add(1);
      for (let n = Math.max(2, S.page - win); n <= Math.min(pages - 1, S.page + win); n++) add(n);
      if (pages > 1) add(pages);
      const uniq = [...new Set(nums)].sort((a, b) => a - b);
      let html = '', last = 0;
      uniq.forEach(n => { if (n - last > 1) html += '<span class="tfh-pager__gap">…</span>'; html += `<button type="button" class="tfh-pager__n${n === S.page ? ' is-on' : ''}" data-page="${n}" ${n === S.page ? 'aria-current="page"' : ''}>${n}</button>`; last = n; });
      pager.innerHTML = total ? `
        <span class="tfh-pager__info">Showing <b>${from.toLocaleString()}–${to.toLocaleString()}</b> of <b>${total.toLocaleString()}</b> products</span>
        <div class="tfh-pager__nav">
          <button type="button" class="tfh-pager__n" data-page="${S.page - 1}" ${S.page === 1 ? 'disabled' : ''} aria-label="Previous page">${ICON.left}</button>
          ${html}
          <button type="button" class="tfh-pager__n" data-page="${S.page + 1}" ${S.page === pages ? 'disabled' : ''} aria-label="Next page">${ICON.chev}</button>
        </div>
        <label class="tfh-pager__size">Per page <select class="tfh-select" data-size>${SIZES.map(n => `<option value="${n}" ${n === S.size ? 'selected' : ''}>${n}</option>`).join('')}</select></label>` : '';
    }
    function placePanel() {
      $$('[data-tfh-panel]', list).forEach(n => n.remove());
      if (!S.open) return;
      const card = $(`[data-tfh-card="${S.open}"]`, list); if (!card) return;
      let last = card;
      if (S.view === 'grid') { const cards = $$('[data-tfh-card]', list), top = card.offsetTop; for (let i = cards.indexOf(card) + 1; i < cards.length && cards[i].offsetTop === top; i++) last = cards[i]; }
      last.insertAdjacentHTML('afterend', panelHTML(Data.byId.get(S.open), { head: S.view === 'grid', gallery: true }));
    }
    function toggle(id) {
      const prev = S.open; S.open = prev === id ? null : id;
      [prev, S.open].filter(Boolean).forEach(pid => { const c = $(`[data-tfh-card="${pid}"]`, list); if (c) c.outerHTML = S.view === 'list' ? rowHTML(Data.byId.get(pid), S.open === pid) : cardHTML(Data.byId.get(pid), S.open === pid); });
      placePanel();
      const row = S.open && $(`[data-tfh-card="${S.open}"]`, list);
      if (row) { const r = row.getBoundingClientRect(), off = headerH() + 80; if (r.top < off || r.top > innerHeight * 0.55) scrollTo({ top: scrollY + r.top - off, behavior: 'smooth' }); }
    }
    addEventListener('resize', debounce(() => S.open && S.view === 'grid' && placePanel(), 150));

    function optList(group, items, cnt, sel, limit) {
      const all = S.more[group], vis = all ? items : items.slice(0, limit);
      return vis.map(([k, label]) => { const n = cnt.get(k) || 0, on = sel.has(k);
        return `<label class="tfh-opt${!n && !on ? ' is-zero' : ''}"><input type="checkbox" data-f="${group}" value="${esc(k)}" ${on ? 'checked' : ''}><span>${esc(label)}</span><em>${n.toLocaleString()}</em></label>`; }).join('') +
        (items.length > limit ? `<button type="button" class="tfh-more" data-more="${group}">${all ? 'Show less' : `Show all ${items.length}`}</button>` : '');
    }
    function facetHTML(g) {
      const pool = Data.products.filter(p => matches(p, g.key)), sel = S[g.key];
      const cnt = n => { let c = 0; for (const p of pool) if (nodeHit(p, n)) c++; return c; };
      const opt = (n, c, cls = '') => `<label class="tfh-opt${cls}${!c && !sel.has(n.k) ? ' is-zero' : ''}"><input type="checkbox" data-ff="${g.key}" value="${esc(n.k)}" ${sel.has(n.k) ? 'checked' : ''}><span>${esc(n.t)}</span><em>${c.toLocaleString()}</em></label>`;
      const rows = g.nodes.map(n => ({ n, c: cnt(n), kids: n.kids.map(k => ({ n: k, c: cnt(k) })).filter(k => k.c || sel.has(k.n.k)) })).filter(r => r.c || sel.has(r.n.k) || r.kids.length);
      if (!rows.length) return '';
      const limit = 8, all = S.more[g.key], vis = all ? rows : rows.slice(0, limit);
      const nSel = sel.size;
      return `<div class="tfh-fg" data-g="${g.key}"><button type="button" class="tfh-fg__h">${esc(g.t)}${nSel ? ` <span class="tfh-fg__n">${nSel}</span>` : ''}</button><div class="tfh-fg__b">
        ${vis.map(({ n, c, kids }) => { const tk = g.key + ':' + n.k, open = S.tree.has(tk) || kids.some(k => sel.has(k.n.k));
          return kids.length ? `<div class="tfh-tree${open ? ' is-open' : ''}"><div class="tfh-tree__row">${opt(n, c)}<button type="button" class="tfh-tree__tog" data-tree="${esc(tk)}" aria-expanded="${open}" aria-label="Show ${esc(n.t)} sub-categories">${ICON.chev}</button></div><div class="tfh-tree__kids">${kids.map(k => opt(k.n, k.c, ' tfh-opt--kid')).join('')}</div></div>` : opt(n, c); }).join('')}
        ${rows.length > limit ? `<button type="button" class="tfh-more" data-more="${g.key}">${all ? 'Show less' : `Show all ${rows.length}`}</button>` : ''}
      </div></div>`;
    }
    function seriesHTML(series, seC) {
      const q = S.seQ.trim().toUpperCase();
      let items = q ? series : series.filter(([k]) => (seC.get(k) || 0) || S.se.has(k));
      if (q) items = items.filter(([k, l]) => k.includes(q) || l.toUpperCase().includes(q));
      items.sort((a, b) => S.se.has(b[0]) - S.se.has(a[0]));
      return `<div class="tfh-fg" data-g="se"><button type="button" class="tfh-fg__h">Model code${S.se.size ? ` <span class="tfh-fg__n">${S.se.size}</span>` : ''}</button><div class="tfh-fg__b">
        <label class="tfh-input tfh-fg__search">${ICON.search}<input type="search" data-se-q value="${esc(S.seQ)}" placeholder="Find a code, e.g. WM" autocomplete="off" aria-label="Find a model code"></label>
        <div data-se-list>${items.length ? optList('se', items, seC, S.se, q ? 40 : 12) : '<span class="tfh-dim">No matching code</span>'}</div></div></div>`;
    }
    function renderFilters() {
      const closed = new Set($$('.tfh-fg.is-closed', root).map(g => g.dataset.g));
      const seC = counts('se', p => [p.s]), prC = counts('price', p => PRICE.filter(x => x[2](p.min)).map(x => x[0]));
      const series = SERIES.map(k => [k, k === 'Other' ? 'No code' : k]);
      const n1 = key => counts(key, p => ((key === 'fresh' ? p.fresh : key === 'cart' ? inCartModels(p) : selModels(p)) ? [1] : [])).get(1) || 0;
      $('[data-filters]', root).innerHTML = `
        ${scope ? `<div class="tfh-scope">${S.scoped ? `<span>Showing <b>${esc(scopeTitle)}</b></span><button type="button" class="tfh-more" data-unscope>Search all products</button>` : `<button type="button" class="tfh-more" data-rescope>← Back to ${esc(scopeTitle)}</button>`}</div>` : ''}
        <div class="tfh-fg" data-g="show"><div class="tfh-fg__b">
          <label class="tfh-switch"><span>New arrivals <em>${n1('fresh')}</em></span><input type="checkbox" data-fresh ${S.fresh ? 'checked' : ''}><i></i></label>
          <label class="tfh-switch"><span>My selection <em>${n1('sel')}</em></span><input type="checkbox" data-selonly ${S.sel ? 'checked' : ''}><i></i></label>
          <label class="tfh-switch"><span>In my cart <em>${n1('cart')}</em></span><input type="checkbox" data-incart ${S.cart ? 'checked' : ''}><i></i></label>
          <label class="tfh-switch"><span>In stock only</span><input type="checkbox" data-stock ${S.stock ? 'checked' : ''}><i></i></label>
        </div></div>
        ${FACETS.map(facetHTML).join('')}
        ${seriesHTML(series, seC)}
        <div class="tfh-fg" data-g="price"><button type="button" class="tfh-fg__h">Price per piece</button><div class="tfh-fg__b">
          ${PRICE.map(([k, l]) => `<label class="tfh-opt${!prC.get(k) && S.price !== k ? ' is-zero' : ''}"><input type="radio" name="tfh-price-${scope || 'all'}" data-price value="${k}" ${S.price === k ? 'checked' : ''}><span>${l}</span><em>${(prC.get(k) || 0).toLocaleString()}</em></label>`).join('')}
          ${S.price ? '<button type="button" class="tfh-more" data-price-clear>Any price</button>' : ''}</div></div>`;
      if (!rendered) { rendered = true; if (!S.se.size) closed.add('se'); if (!S.price) closed.add('price'); }
      closed.forEach(g => { const el = $(`.tfh-fg[data-g="${g}"]`, root); if (el) el.classList.add('is-closed'); });
      const nf = FACETS.reduce((n, g) => n + S[g.key].size, 0) + S.th.size + S.se.size + S.ty.size + (S.price ? 1 : 0) + (S.fresh ? 1 : 0) + (S.cart ? 1 : 0) + (S.sel ? 1 : 0);
      $('[data-open-filters] span', root).textContent = nf ? `Filters · ${nf}` : 'Filters';
    }
    function renderMeta() {
      const chips = [];
      if (S.q.length) chips.push(['q', '', `“${S.qRaw}”`]);
      FACETS.forEach(g => S[g.key].forEach(k => { const n = g.byKey.get(k); chips.push([g.key, k, n ? n.t : k]); }));
      S.se.forEach(k => chips.push(['se', k, k === 'Other' ? 'No code' : `${k} code`]));
      S.th.forEach(k => chips.push(['th', k, (CFG.themes.find(t => t.h === k) || {}).t || k]));
      S.ty.forEach(k => chips.push(['ty', k, k]));
      if (S.price) chips.push(['price', '', PRICE.find(x => x[0] === S.price)[1]]);
      if (S.fresh) chips.push(['fresh', '', 'New arrivals']);
      if (S.sel) chips.push(['sel', '', 'My selection']);
      if (S.cart) chips.push(['cart', '', 'In my cart']);
      const models = S.list.reduce((n, p) => n + p.v.length, 0);
      $('[data-meta]', root).innerHTML = `<span class="tfh-count"><b>${S.list.length.toLocaleString()}</b> products · ${models.toLocaleString()} models${Data.complete ? '' : '<span class="tfh-dim"> · loading…</span>'}</span>` +
        chips.map(([g, k, l]) => `<span class="tfh-chip">${esc(l)}<button type="button" data-unchip="${g}" data-k="${esc(k)}" aria-label="Remove ${esc(l)}">${ICON.x}</button></span>`).join('') +
        (chips.length ? '<button type="button" class="tfh-link" data-clear>Clear all</button>' : '');
    }
    const refreshCounts = debounce(() => { renderFilters(); if (S.cart || S.sel) apply(true); }, 200);
    Cart.on(vids => { if (!vids) refreshCounts(); });
    Draft.on(() => { if (S.sel) refreshCounts(); else renderFilters(); });

    function writeUrl() {
      const u = new URLSearchParams();
      if (S.q.length) u.set('q', S.qRaw);
      FACETS.forEach(g => { if (S[g.key].size) u.set(g.slug, [...S[g.key]].join(',')); });
      if (S.se.size) u.set('series', [...S.se].join(','));
      if (S.th.size) u.set('theme', [...S.th].join(',')); if (S.ty.size) u.set('type', [...S.ty].join(','));
      if (S.price) u.set('price', S.price); if (S.fresh) u.set('new', '1'); if (S.cart) u.set('incart', '1'); if (S.sel) u.set('selected', '1'); if (!S.stock) u.set('all', '1');
      if (S.sort !== 'new') u.set('sort', S.sort); if (S.page > 1) u.set('page', S.page);
      const path = scope && !S.scoped ? ALL() : location.pathname, s = u.toString();
      history.replaceState(history.state, '', path + (s ? '?' + s : ''));
    }
    function readUrl() {
      const u = new URLSearchParams(location.search);
      if (u.get('q')) { input.value = u.get('q'); setQuery(u.get('q'), true); }
      (u.get('series') || '').split(',').filter(Boolean).forEach(k => S.se.add(k.toUpperCase() === 'OTHER' ? 'Other' : k.toUpperCase()));
      FACETS.forEach(g => (u.get(g.slug) || '').split(',').filter(Boolean).forEach(k => { if (g.byKey.has(k)) S[g.key].add(k); }));
      S.price = u.get('price') || ''; S.fresh = u.get('new') === '1'; S.cart = u.get('incart') === '1'; S.sel = u.get('selected') === '1'; S.stock = u.get('all') !== '1';
      S.sort = SORTS[u.get('sort')] ? u.get('sort') : 'new'; $('[data-sort]', root).value = S.sort;
      S.page = Math.max(1, parseInt(u.get('page') || '1', 10) || 1);
      if (u.get('view') === 'grid' || u.get('view') === 'list') S.view = u.get('view');
      if (u.get('bulk') === '1' || root.dataset.openBulk === 'true') setTimeout(openBulk, 60);
    }
    function setQuery(v, silent) { S.qRaw = v.trim(); S.q = S.qRaw.toLowerCase().split(/\s+/).filter(Boolean); if (!silent) apply(); }
    function clearAll() { S.q = []; S.qRaw = ''; input.value = ''; S.th.clear(); S.se.clear(); S.ty.clear(); FACETS.forEach(g => S[g.key].clear()); S.price = ''; S.fresh = false; S.cart = false; S.sel = false; apply(); }

    input.addEventListener('input', debounce(e => setQuery(e.target.value), 100));
    root.addEventListener('input', debounce(e => { if (!e.target.matches('[data-se-q]')) return; S.seQ = e.target.value; const box = $('[data-se-list]', root), tmp = document.createElement('div');
      const seC = counts('se', p => [p.s]); tmp.innerHTML = seriesHTML(SERIES.map(k => [k, k === 'Other' ? 'No code' : k]), seC); box.innerHTML = $('[data-se-list]', tmp).innerHTML; }, 80));
    input.addEventListener('keydown', e => { if (e.key === 'Enter') { e.preventDefault(); input.blur(); if (S.list.length === 1) toggle(S.list[0].i); } if (e.key === 'Escape') { input.value = ''; setQuery(''); } });
    $('[data-sort]', root).addEventListener('change', e => { S.sort = e.target.value; apply(); });

    root.addEventListener('change', e => {
      const t = e.target;
      if (t.dataset.f) { t.checked ? S[t.dataset.f].add(t.value) : S[t.dataset.f].delete(t.value); apply(); }
      else if (t.dataset.ff) { t.checked ? S[t.dataset.ff].add(t.value) : S[t.dataset.ff].delete(t.value); apply(); }
      else if (t.hasAttribute('data-price')) { S.price = t.value; apply(); }
      else if (t.hasAttribute('data-fresh')) { S.fresh = t.checked; apply(); }
      else if (t.hasAttribute('data-incart')) { S.cart = t.checked; apply(); }
      else if (t.hasAttribute('data-selonly')) { S.sel = t.checked; apply(); }
      else if (t.hasAttribute('data-stock')) { S.stock = t.checked; apply(); }
      else if (t.hasAttribute('data-size')) { S.size = +t.value; store.set('tfh-size', S.size); S.page = 1; renderPage(true); writeUrl(); }
    });
    root.addEventListener('keydown', e => { if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-tfh-card]')) { e.preventDefault(); toggle(+e.target.dataset.tfhCard); } });
    root.addEventListener('click', e => {
      const t = e.target, c = s => t.closest(s); let el;
      if (c('.tfh-step') || c('[data-tfh-zoom]') || c('[data-tfh-gal-th]') || c('[data-tfh-each]') || c('[data-tfh-reset]') || c('[data-tfh-add-product]') || c('[data-tfh-open-bulk]') || c('[data-tfh-open-cart]') || c('.tfh-panel a')) return;
      if ((el = c('[data-tfh-card]'))) return toggle(+el.dataset.tfhCard);
      if ((el = c('[data-page]'))) { if (el.disabled) return; S.page = +el.dataset.page; S.open = null; renderPage(true); writeUrl(); return; }
      if ((el = c('[data-viewbtn]'))) { S.view = el.dataset.viewbtn; store.set('tfh-view2', S.view); return renderPage(); }
      if ((el = c('[data-tree]'))) { const k = el.dataset.tree, tr = el.closest('.tfh-tree'), open = !tr.classList.contains('is-open'); tr.classList.toggle('is-open', open); el.setAttribute('aria-expanded', open); open ? S.tree.add(k) : S.tree.delete(k); return; }
      if ((el = c('[data-more]'))) { S.more[el.dataset.more] = !S.more[el.dataset.more]; return renderFilters(); }
      if (c('[data-price-clear]')) { S.price = ''; return apply(); }
      if (c('[data-show-soldout]')) { S.stock = false; return apply(); }
      if (c('[data-unscope]')) { S.scoped = false; return apply(); }
      if (c('[data-rescope]')) { S.scoped = true; return apply(); }
      if ((el = c('[data-unchip]'))) { const g = el.dataset.unchip; if (g === 'q') { input.value = ''; return setQuery(''); } if (g === 'price') S.price = ''; else if (g === 'fresh') S.fresh = false; else if (g === 'cart') S.cart = false; else if (g === 'sel') S.sel = false; else S[g].delete(el.dataset.k); return apply(); }
      if (c('[data-clear]')) { sheet.classList.remove('is-filters'); return clearAll(); }
      if (c('[data-open-filters]')) return sheet.classList.add('is-filters');
      if (c('[data-close]')) return sheet.classList.remove('is-filters');
      if ((el = c('.tfh-fg__h'))) el.parentElement.classList.toggle('is-closed');
    });

    function computeLists() {
      CFG.themes.forEach(t => { t.n = Data.products.filter(p => p.th.includes(t.h)).length; });
      const all = new Map(); Data.products.forEach(p => all.set(p.s, (all.get(p.s) || 0) + 1));
      SERIES = [...all].sort((a, b) => (a[0] === 'Other') - (b[0] === 'Other') || b[1] - a[1]).map(x => x[0]);
    }
    list.innerHTML = '<div class="tfh-skel"></div>'.repeat(8);
    Promise.all([Data.load(), Cart.load()]).then(() => { computeLists(); readUrl(); apply(true); })
      .catch(err => { list.innerHTML = `<div class="tfh-empty"><b>Could not load the catalog</b><span>${esc(err.message)}</span><button type="button" class="tfh-btn" onclick="sessionStorage.clear();location.reload()">Reload</button></div>`; });
    Data.onRefresh(() => { computeLists(); apply(true); });
  }

  /* ================= product rows ================= */
  function Rail(root) {
    const mode = root.dataset.mode || 'new', val = root.dataset.value || '', limit = +root.dataset.limit || 12, exclude = +root.dataset.exclude || 0;
    const track = $('[data-rail-track]', root) || root;
    track.innerHTML = '<div class="tfh-skel tfh-skel--card"></div>'.repeat(6);
    const pick = () => {
      let l = Data.products.filter(p => p.avail && p.i !== exclude);
      const me = Data.byId.get(exclude);
      if (mode === 'series') l = l.filter(p => p.s === val.toUpperCase());
      else if (mode === 'collection') l = l.filter(p => p.cols.includes(val));
      else if (mode === 'same-series') l = me && me.s !== 'Other' ? l.filter(p => p.s === me.s) : [];
      else if (mode === 'same-collection') { const th = new Set(me ? me.th : []); l = l.filter(p => p.th.some(h => th.has(h))); }
      return l.sort(SORTS.new).slice(0, limit);
    };
    const render = () => { const l = pick(), sec = root.closest('.shopify-section') || root; sec.hidden = !l.length; if (l.length) track.innerHTML = l.map(p => cardHTML(p)).join(''); };
    Promise.all([Data.load(), Cart.load()]).then(render).catch(() => { root.hidden = true; });
    Data.onRefresh(render);
    root.addEventListener('click', e => {
      const nav = e.target.closest('[data-rail-nav]');
      if (nav) { track.scrollBy({ left: (+nav.dataset.railNav) * track.clientWidth * 0.9, behavior: 'smooth' }); return; }
      const card = e.target.closest('[data-tfh-card]'); if (card) openProduct(Data.byId.get(+card.dataset.tfhCard));
    });
    root.addEventListener('keydown', e => { if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-tfh-card]')) { e.preventDefault(); openProduct(Data.byId.get(+e.target.dataset.tfhCard)); } });
  }
  function openProduct(p) {
    overlay('tfh-qv', `<header class="tfh-modal__head"><div class="tfh-qv__head"><img src="${esc(imgUrl(p.img, 160))}" alt=""><div><h2>${esc(p.t)}</h2><p>${esc(p.s)} · ${plural(p.v.length, 'model')} · ${priceLabel(p)} · <a href="/products/${esc(p.h)}">Product details</a></p></div></div><button type="button" class="tfh-icon" data-tfh-ov-close aria-label="Close">${ICON.x}</button></header>
      <div class="tfh-qv__body">${panelHTML(p, { head: false, gallery: true })}</div>`);
  }

  /* ================= series index ================= */
  function SeriesTiles(root) {
    const codes = (root.dataset.codes || '').split(',').map(s => s.trim().toUpperCase()).filter(Boolean);
    const render = () => {
      const by = new Map(); Data.products.forEach(p => { if (!by.has(p.s)) by.set(p.s, []); by.get(p.s).push(p); });
      const keys = (codes.length ? codes : [...by.keys()].filter(k => k !== 'Other').sort((a, b) => by.get(b).length - by.get(a).length).slice(0, 12)).filter(k => by.has(k));
      root.innerHTML = keys.map(k => { const ps = by.get(k).slice().sort(SORTS.new), fresh = ps.filter(p => p.fresh).length;
        return `<a class="tfh-series" href="${ALL()}?series=${encodeURIComponent(k)}"><span class="tfh-series__code">${esc(k)}</span>
          <span class="tfh-series__imgs">${ps.slice(0, 3).map(p => `<img loading="lazy" src="${esc(imgUrl(p.img, 120))}" alt="">`).join('')}</span>
          <span class="tfh-series__meta">${plural(ps.length, 'product')}${fresh ? ` · <em>${fresh} new</em>` : ''}</span></a>`; }).join('');
    };
    Data.load().then(render).catch(() => {});
    Data.onRefresh(render);
  }

  /* ================= product page ================= */
  function ProductPage(root) {
    const mount = $('[data-tfh-product-vars]', root);
    let raw; try { raw = JSON.parse($('script[data-tfh-product-json]', root).textContent); } catch (e) { return; }
    const prod = () => Data.ensure(raw);
    prod();
    Cart.load().then(() => { mount.innerHTML = panelHTML(prod(), { head: false, link: false }); });
    Data.load().then(prod).catch(() => {});
    Data.onRefresh(prod);
    root.addEventListener('click', e => {
      const th = e.target.closest('[data-tfh-thumb]');
      if (th) { const main = $('[data-tfh-main-img]', root); main.src = th.dataset.src; main.closest('[data-tfh-zoom]').dataset.tfhZoom = th.dataset.zoom; $$('[data-tfh-thumb]', root).forEach(x => x.classList.toggle('is-on', x === th)); }
    });
  }

  /* ================= cart page ================= */
  function CartPage(root) {
    const body = $('[data-cart-body]', root);
    const totals = () => { $('[data-c-models]', root).textContent = Cart.models; $('[data-c-units]', root).textContent = Cart.count.toLocaleString(); $('[data-c-total]', root).textContent = money(Cart.total); };
    const render = () => {
      if (body.contains(document.activeElement) && document.activeElement.tagName === 'INPUT') return;
      root.classList.toggle('is-empty', !Cart.lines.length);
      const s = Draft.totals(), selBox = $('[data-cart-sel]', root);
      if (selBox) selBox.innerHTML = s.models ? `<div class="tfh-drawer__sel"><span>You have <b>${s.models}</b> selected models (${s.units.toLocaleString()} pcs, ${money(s.total)}) that are not in the cart yet.</span><button type="button" class="tfh-btn tfh-btn--sm tfh-btn--pri" data-tfh-add-all>Add to cart</button></div>` : '';
      if (!Cart.lines.length) return;
      ensureLines();
      body.innerHTML = cartGroups().map(g => {
        const sub = g.lines.reduce((t, l) => t + l.final_line_price, 0), units = g.lines.reduce((t, l) => t + l.quantity, 0);
        return `<section class="tfh-cgrp"><header class="tfh-cgrp__h"><a href="${esc(g.url)}" class="tfh-cgrp__img">${g.img ? `<img src="${esc(imgUrl(g.img, 120))}" alt="" loading="lazy">` : ''}</a>
          <div><a href="${esc(g.url)}" class="tfh-cgrp__t">${esc(g.title)}</a><span>${plural(g.lines.length, 'model')} · ${units.toLocaleString()} pcs</span></div><b>${money(sub)}</b></header>
          <div class="tfh-vt tfh-vt--cart">${g.lines.map(l => { const p = Data.byVar.get(l.variant_id), v = p && Data.variant(l.variant_id);
            return `<div class="tfh-vt__row" data-tfh-vid="${l.variant_id}"><span class="tfh-vt__img">${l.image ? `<img src="${esc(imgUrl(l.image, 120))}" alt="" loading="lazy">` : ''}</span>
              <span class="tfh-vt__name" title="${esc(l.variant_title || l.title)}">${esc(l.variant_title || l.title)}</span><span class="tfh-vt__price">${money(l.final_price)}</span>
              ${stepper(l.variant_id, p, v, 'cart')}
              <span class="tfh-vt__line">${money(l.final_line_price)}</span>
              <button type="button" class="tfh-icon tfh-vt__rm" data-rm="${l.variant_id}" aria-label="Remove">${ICON.x}</button></div>`; }).join('')}</div></section>`;
      }).join('');
      totals();
    };
    const go = debounce(render, 80);
    Cart.on(vids => { if (!vids) go(); else totals(); });
    Draft.on(go);
    root.addEventListener('click', e => { const rm = e.target.closest('[data-rm]'); if (rm) { const vid = +rm.dataset.rm, q = Cart.get(vid); Cart.set(vid, 0); toast('Removed from cart', { action: ['Undo', () => Cart.set(vid, q)] }); } });
    Promise.all([Cart.load(), Data.load().catch(() => {})]).then(render);
    const note = $('[data-cart-note]', root);
    if (note) note.addEventListener('input', debounce(() => fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }), 500));
  }

  /* ================= header ================= */
  /* Header is Dawn's section (Theme editor → Header). Keep sticky offsets in sync with it. */
  function headerH() { const h = $('.section-header'); return h ? Math.max(0, h.getBoundingClientRect().bottom) : 0; }
  function Header() {
    const h = $('.section-header'); if (!h) return;
    const sync = () => document.documentElement.style.setProperty('--tfh-header-h', h.getBoundingClientRect().height + 'px');
    sync(); addEventListener('resize', debounce(sync, 100));
  }

  /* ================= boot ================= */
  const MOUNTS = { 'data-tfh-quick': QuickOrder, 'data-tfh-catalog': Catalog, 'data-tfh-rail': Rail, 'data-tfh-series': SeriesTiles, 'data-tfh-product': ProductPage, 'data-tfh-cart': CartPage };
  function mountAll(scope = document) {
    for (const [attr, fn] of Object.entries(MOUNTS)) $$(`[${attr}]:not([data-tfh-mounted])`, scope).forEach(el => { el.setAttribute('data-tfh-mounted', ''); try { fn(el); } catch (e) { console.error('[tfh]', e); } });
  }
  window.TFH = { CFG, Data, Cart, Draft, money, toast, mountAll, openDrawer, openPalette, openBulk, openProduct, addSelection };
  document.addEventListener('shopify:section:load', e => mountAll(e.target));
  const boot = () => {
    Header(); mountAll();
    Cart.load().then(() => { headerCart(); selectionBar(); });
    if (Draft.map.size) Data.load().then(selectionBar).catch(() => {});
    selectionBar();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
